import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingBasisHomeworkMode } from '../../../../mechanics/rid-reading-basis-homework-mode/rid-reading-basis-homework-mode';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-reading-basis-homework-mode-per-sound-page',
  imports: [RidReadingBasisHomeworkMode],
  templateUrl: './reading-basis-homework-mode-per-sound-page.html',
})
export class ReadingBasisHomeworkModePerSoundPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly pace = computed(() => parseInt(this.queryParams()['pace'] ?? '500'));
  protected readonly pause = computed(() => parseInt(this.queryParams()['pause'] ?? '500'));
}
